'use strict';

const { valueIsNotNull } = require('./localisation-parser');

function getCategoryNames({ categoryIds, I18n, limit }) {
  const categoryNames = [];

  if (!Array.isArray(categoryIds) || !categoryIds.length) {
    return categoryNames;
  }

  const categoryLimit = categoryIds.length === limit ? limit : 1;

  categoryIds.slice(0, categoryLimit).forEach(id => {
    const categoryName = I18n.t(`js.modules.category.Name.${id}`);
    if (valueIsNotNull(categoryName)) {
      categoryNames.push(categoryName);
    }
  });

  return categoryNames;
}

function getRelatedTableClass(coupons, amountBeforeInlineContent) {
  if (Array.isArray(coupons) && coupons.length <= amountBeforeInlineContent) {
    return 'category-related-item-last';
  }

  return 'category-related-item';
}

module.exports = {
  getCategoryNames,
  getRelatedTableClass,
};
